let options;

export const init = () => {
  const checkbox = cube.$id('js-btob-checkbox');
  const select = cube.$id('js-national-id-type');
  const block = cube.$id('js-national-id-block');
  if (!select) return;

  options = select.$$('option');

  if (checkbox)
    checkbox.on('change', () => updateContext(select, checkbox, block));

  select.on('change', displayNationalIdField);

  updateContext(select, checkbox, block);
};


/**
 * Display or hide the national id field.
 *
 */
function displayNationalIdField () {
  const container = cube.$id('national-id-field-container');
  const { classList } = container;
  const selected = this.$('option:checked');

  if (this) {
    resetInputStatus(this);
    updateNationalIdField(selected);
    classList.remove('hidden');
  }
  else {
    classList.add('hidden');
  }
};


/**
 * Update the national id field rules depending on the selected national id type.
 *
 * @param {HTMLOptionElement} selected the selected option.
 */
const updateNationalIdField = (selected) => {
  const { placeholder, required, pattern } = selected.dataset;
  const field = cube.$id('national-id-field');

  resetInputStatus(field);

  field.required = required;
  field.placeholder = placeholder;
  field.value = selected.value === field.dataset.type
    ? field.dataset.value : '';
  field.pattern = selected.value === 'DNI'
    ? $(field).rules('add', { DNI: true }) && ''
    : $(field).rules('remove', 'DNI') && pattern;

};


/**
 * Set options to the national id type field depending on the customer type (B2B, B2C).
 * If there are no options available, we hide the national id block.
 *
 * @param {HTMLSelectElement} select the national id type select.
 * @param {HTMLInputElement} checkbox the customer type checkbox. (only in create account process)
 * @param {HTMLSelectElement} block the national id block.
 */
const updateContext = (select, checkbox, block) => {
  let { value } = select;
  let atLeastOneOption = false;
  const context = (checkbox && checkbox.checked || select.hasAttribute('data-isb2b'))
    ? 'B2B'
    : 'B2C';

  select.$$('option').forEach(option => option.remove());

  options.forEach(option => {
    if (option.dataset.selected === context || option.dataset.selected === 'ALL')
      value = option.value;

    if (!option.dataset.context || option.dataset.context === 'ALL' || option.dataset.context === context)
      select.appendChild(option);

    atLeastOneOption = atLeastOneOption || option.dataset.context === 'ALL' || option.dataset.context === context;
  });

  $(select)
    .selectpicker('val', value)
    .selectpicker('refresh');

  if (atLeastOneOption)
    block.classList.remove('hidden');
  else
    block.classList.add('hidden');

  select.dispatchEvent(new CustomEvent('change'));
};


/**
 * Remove icon validation and error message from the national id field.
 *
 * @param {HTMLInputElement} field the national id field.
 */
const resetInputStatus = field => {
  field.closest('.form-group').classList.remove('has-error', 'validated');
};



// WEBPACK FOOTER //
// ./src/customer/customer-national-id.js